import { Degree } from 'api/data.types'

export const INFANT = Degree.INFANT
export const FIRST_YEAR = Degree.FIRST_YEAR
export const SECOND_YEAR = Degree.SECOND_YEAR
export const THIRD_YEAR = Degree.THIRD_YEAR
export const FOURTH_YEAR = Degree.FOURTH_YEAR
export const FIFTH_YEAR = Degree.FIFTH_YEAR
export const SIXTH_YEAR = Degree.SIXTH_YEAR
export const SEVENTH_YEAR = Degree.SEVENTH_YEAR
export const EIGHTH_YEAR = Degree.EIGHTH_YEAR
export const NINETH_YEAR = Degree.NINETH_YEAR
export const COLLEGE = Degree.COLLEGE
export const EJA = Degree.EJA

export const availableDegrees = [
  INFANT,
  FIRST_YEAR,
  SECOND_YEAR,
  THIRD_YEAR,
  FOURTH_YEAR,
  FIFTH_YEAR,
  SIXTH_YEAR,
  SEVENTH_YEAR,
  EIGHTH_YEAR,
  NINETH_YEAR,
  COLLEGE,
  EJA,
  Degree.CORPORATE,
  Degree.TEACHER
]

export const childEducationDegreeMap = [Degree.INFANT]
export const kidsDegreeMap = [
  Degree.INFANT,
  Degree.FIRST_YEAR,
  Degree.SECOND_YEAR,
  Degree.THIRD_YEAR,
  Degree.FOURTH_YEAR,
  Degree.FIFTH_YEAR
]
export const kids2DegreeMap = [
  Degree.THIRD_YEAR,
  Degree.FOURTH_YEAR,
  Degree.FIFTH_YEAR
]
export const fundamental1DegreeMap = [
  Degree.FIRST_YEAR,
  Degree.SECOND_YEAR,
  Degree.THIRD_YEAR,
  Degree.FOURTH_YEAR,
  Degree.FIFTH_YEAR,
  Degree.EF1
]
export const fundamental2DegreeMap = [
  Degree.SIXTH_YEAR,
  Degree.SEVENTH_YEAR,
  Degree.EIGHTH_YEAR,
  Degree.NINETH_YEAR,
  Degree.EF2
]
export const mediumDegreeMap = [
  Degree.COLLEGE,
  Degree.COLLEGE_1,
  Degree.COLLEGE_2,
  Degree.COLLEGE_3,
  Degree.EJA,
  Degree.COLLEGE_EM
]
export const mediumDegreeMapWithoutEm = [Degree.COLLEGE, Degree.EJA]
export const teacherDegreeMap = [Degree.CORPORATE, Degree.TEACHER]
export const nonSchoolMap = [Degree.TEACHER, Degree.NON_SCHOOL]
